import React from "react";
import { Select } from "antd";

export const FilterDriverFieldSelector = ({
    selectedFieldDriverName,
    setSelectedFieldDriverName,
    metaDataDrivers,
    setDisplayName,
    widget
}) => (
    <Select
        // mode="multiple"
        showSearch
        style={{ width: 150 }}
        placeholder="Select Filter Driver Field"
        value={
            selectedFieldDriverName
                ? selectedFieldDriverName
                : metaDataDrivers[0].name
        }
        onChange={(value) => {
            setSelectedFieldDriverName(value);
            setDisplayName(`${widget.text} ${value}`)
        }}
        options={metaDataDrivers}
        fieldNames={{ label: "name", value: "name" }}
        size="small"
    />
);
